enum SearchOptionsShowType {
	Closed,
	QuickResult,
	AdvancedSearch
}

export default SearchOptionsShowType;
